import { PYTHON_BACKEND } from '@constants/env';
import { ApiEndpoint, ContentType, HttpHeader, HttpMethod } from '@constants/http';

export async function deleteQueryLogs(queryLogIds: string[]): Promise<boolean> {
  if (queryLogIds.length === 0) {
    return true;
  }

  const baseUrl = PYTHON_BACKEND;
  const endpoint = ApiEndpoint.QueryLogsBulkDelete;
  const searchParams = new URLSearchParams();

  queryLogIds.forEach((queryLogId) => searchParams.append('query_log_ids', queryLogId));

  const url = `${baseUrl}/${endpoint}/?${searchParams.toString()}`;
  const requestOptions = {
    method: HttpMethod.DELETE,
    headers: {
      [HttpHeader.ContentType]: ContentType.JSON,
    },
  };

  try {
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      let errorMessage = '[api.delete-query-logs]: Something went wrong!';

      try {
        const data = await response.json();
        if (data?.message) {
          errorMessage = data.message;
        }
      } catch {
        // Ignore response parsing errors and use the fallback message.
      }

      throw new Error(errorMessage);
    }

    return true;
  } catch (error: unknown) {
    console.error(error);
    return false;
  }
}
